import { API_ENDPOINTS } from '@/api/endpoints';
import { apiFetch } from '@/util/apiClient';
import { useQuery } from '@tanstack/react-query';
import { HVAC } from '../types';

export const useHVACQuery = () => {
  return useQuery({
    queryKey: ['hvac'],
    queryFn: () => apiFetch<HVAC[]>(API_ENDPOINTS.COMMON.technology.hvac),
    staleTime: 5 * 60 * 1000,
  });
};
